
import { useState, useEffect } from 'react';
import { Instagram } from 'lucide-react';
import { useInView } from '../utils/animations';
import { useToast } from "@/hooks/use-toast";
import { 
  fetchInstagramData, 
  getFallbackPosts, 
  FormattedInstagramPost 
} from '@/utils/instagram';
import InstagramHeader from './instagram/InstagramHeader';
import InstagramGrid from './instagram/InstagramGrid';
import { Button } from '@/components/ui/button';

const InstagramFeed = () => {
  const { toast } = useToast();
  const [titleRef, titleInView] = useInView({ threshold: 0.1 });
  const [feedRef, feedInView] = useInView({ threshold: 0.1 });
  const [loading, setLoading] = useState(true);
  const [posts, setPosts] = useState<FormattedInstagramPost[]>([]);
  const [tokenExpired, setTokenExpired] = useState(false);
  
  useEffect(() => {
    fetchInstagramPosts();
  }, []);

  const fetchInstagramPosts = async () => {
    try {
      const formattedPosts = await fetchInstagramData();
      setPosts(formattedPosts);
      setTokenExpired(false);
    } catch (error) {
      console.error('Błąd pobierania danych z Instagrama:', error);
      
      // Check if token expired
      if ((error as Error).message === 'token_expired') {
        setTokenExpired(true);
      }
      
      // Use fallback posts
      const fallbackPosts = getFallbackPosts();
      setPosts(fallbackPosts);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="instagram" className="section bg-elegant-50">
      <div className="container-custom">
        <div ref={titleRef as any}>
          <InstagramHeader inView={titleInView} tokenExpired={tokenExpired} />
        </div>
        
        {loading ? (
          <div className="flex justify-center items-center min-h-[200px]">
            <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-elegant-900"></div>
          </div>
        ) : (
          <div ref={feedRef as any}>
            <InstagramGrid posts={posts} inView={feedInView} />
          </div>
        )}
        
        <div className="mt-8 text-center">
          <a
            href="https://www.instagram.com/czule.klisze/"
            target="_blank"
            rel="noopener noreferrer"
            className="elegant-button-outline inline-flex items-center"
          >
            <Instagram className="mr-2 h-4 w-4" />
            Obserwuj @czule.klisze
          </a>
        </div>
      </div>
    </section>
  );
};

export default InstagramFeed;
